module.exports = __webpack_public_path__ + "static/media/mappa-google-terreno.d74688f9.png";